export default __webpack_public_path__ + "static/media/house-4.f5a28bdc.jpg";